import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { TRANSACTIONDETAIL } from "../../../../services/ApiCalls";
import { catchAsync } from "../../../../utilities/utilities";
import Loader from "../../../../components/Common/Loader";
import moment from "moment";

const TransactionDetail = () => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [transaction, setTransaction] = useState(null);
  const [hotelDetail, setHotelDetail] = useState(null);
  const [bookingDetail, setBookingDetail] = useState(null);
  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await TRANSACTIONDETAIL(id);

    if (res.status === 200 && res.data) {
      const data = res.data.data;
      setTransaction(data);
      setHotelDetail(data.hotelId);
      setBookingDetail(data.bookingId);
    }
    setLoader(false);
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  if (loader) return <Loader />;

  return (
    <section className="detail position-relative py-3">
      <Container>
        <Row>
          <Col lg="12">
            <div className="d-flex align-items-center gap-10">
              <Button
                onClick={() => navigate(-1)}
                className="border d-flex align-items-center p-2 rounded"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 10 16"
                  fill="none"
                >
                  <path
                    d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                    fill="#fff"
                    stroke="#1E232C"
                    strokeWidth="0.2"
                  />
                </svg>
              </Button>
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                Transaction Details
              </h4>
            </div>
          </Col>

          <Col lg="6" className="my-2">
            <label className="form-label fw-bold">Transaction Info</label>
            <div
              className="cardCstm px-3 py-2 rounded"
              style={{ background: "#eee" }}
            >
              <ul className="list-unstyled mb-0">
                <li className="py-2 d-flex">
                  <strong className="w-50">Transaction ID:</strong>{" "}
                  {transaction?.transactionId}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Amount:</strong>{" "}
                  {transaction?.currencySymbol}
                  {transaction?.amount}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Currency:</strong>{" "}
                  {transaction?.currency}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Payment Method:</strong>{" "}
                  {transaction?.paymentMethod}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Status:</strong>{" "}
                  {transaction?.status}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Created At:</strong>{" "}
                  {moment(transaction?.createdAt).format("MM-DD-YYYY, HH:mm")}
                </li>
              </ul>
            </div>
          </Col>

          {/* Hotel Info */}
          <Col lg="6" className="my-2">
            <label className="form-label fw-bold">Hotel Details</label>
            <div
              className="cardCstm px-3 py-2 rounded"
              style={{ background: "#eee" }}
            >
              <ul className="list-unstyled mb-0">
                <li className="py-2 d-flex">
                  <strong className="w-50">Hotel Name:</strong>{" "}
                  {hotelDetail?.hotelName}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Hotel ID:</strong>{" "}
                  {hotelDetail?.hotelId}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Email:</strong> {hotelDetail?.email}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Phone:</strong>{" "}
                  {hotelDetail?.mobileNumber}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Address:</strong>{" "}
                  {hotelDetail?.address}, {hotelDetail?.city},{" "}
                  {hotelDetail?.state}, {hotelDetail?.country}
                </li>
              </ul>
            </div>
          </Col>

          {/* Booking Info */}
          <Col lg="6" className="my-2">
            <label className="form-label fw-bold">Booking Details</label>
            <div
              className="cardCstm px-3 py-2 rounded"
              style={{ background: "#eee" }}
            >
              <ul className="list-unstyled mb-0">
                <li className="py-2 d-flex">
                  <strong className="w-50">Booking ID:</strong>{" "}
                  {bookingDetail?.bookingId}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Check-In:</strong>{" "}
                  {moment(bookingDetail?.checkInDate).format(
                    "MM-DD-YYYY, HH:mm"
                  )}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Check-Out:</strong>{" "}
                  {moment(bookingDetail?.checkOutDate).format(
                    "MM-DD-YYYY, HH:mm"
                  )}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Guests:</strong>{" "}
                  {bookingDetail?.numberOfGuests}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Nights:</strong>{" "}
                  {bookingDetail?.nightCount}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Price:</strong>{" "}
                  {bookingDetail?.currencySymbol}
                  {bookingDetail?.price}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Discount:</strong>{" "}
                  {bookingDetail?.currencySymbol}
                  {bookingDetail?.discount}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Final Price:</strong>{" "}
                  {bookingDetail?.currencySymbol}
                  {bookingDetail?.finalPrice}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Taxes:</strong>{" "}
                  {bookingDetail?.currencySymbol}
                  {bookingDetail?.taxes}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Booking Status:</strong>{" "}
                  {bookingDetail?.bookingStatus}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Payment Status:</strong>{" "}
                  {bookingDetail?.paymentStatus}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Special Requests:</strong>{" "}
                  {bookingDetail?.specialRequests}
                </li>
                <li className="py-2 d-flex">
                  <strong className="w-50">Booking Type:</strong>{" "}
                  {bookingDetail?.bookingType}
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TransactionDetail;
